/**
 * HubSpot Meetings, Calendly, and Google Calendar appointment pages all render
 * inside an iframe when asked to; only the first two tell the parent window
 * when a slot is booked. Any other link is framed as-is and reports nothing.
 */
export function embedBookingUrl(bookingUrl: string, host: string): string {
  const url = new URL(bookingUrl);
  if (url.hostname === "meetings.hubspot.com") {
    url.searchParams.set("embed", "true");
  } else if (url.hostname.endsWith("calendly.com")) {
    url.searchParams.set("embed_domain", host);
    url.searchParams.set("embed_type", "Inline");
  } else if (url.hostname === "calendar.google.com") {
    url.searchParams.set("gv", "true");
  }
  return url.toString();
}

function bookingOrigin(bookingUrl: string): string {
  return new URL(bookingUrl).origin;
}

/** A booking confirmation posted by the framed calendar, from its own origin only. */
export function isBookingConfirmedMessage(
  message: { origin: string; data: unknown },
  bookingUrl: string,
): boolean {
  if (message.origin !== bookingOrigin(bookingUrl)) {
    return false;
  }
  const data = message.data;
  if (!data || typeof data !== "object") {
    return false;
  }
  const record = data as Record<string, unknown>;
  return (
    record.meetingBookSucceeded === true ||
    record.event === "calendly.event_scheduled"
  );
}
